var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 1.33301C4.33325 1.33301 1.33325 4.33301 1.33325 7.99967C1.33325 11.6663 4.33325 14.6663 7.99992 14.6663C11.6666 14.6663 14.6666 11.6663 14.6666 7.99967C14.6666 4.33301 11.6666 1.33301 7.99992 1.33301ZM8.66658 10.6663C8.66658 11.0663 8.39992 11.333 7.99992 11.333C7.59992 11.333 7.33325 11.0663 7.33325 10.6663V7.99967C7.33325 7.59967 7.59992 7.33301 7.99992 7.33301C8.39992 7.33301 8.66658 7.59967 8.66658 7.99967V10.6663ZM7.99992 5.99967C7.59992 5.99967 7.33325 5.73301 7.33325 5.33301C7.33325 4.93301 7.59992 4.66634 7.99992 4.66634C8.39992 4.66634 8.66658 4.93301 8.66658 5.33301C8.66658 5.73301 8.39992 5.99967 7.99992 5.99967Z",
    fill: "#6C6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.4669410c947a5b3fab572d81d8233ba1.svg";
export { ForwardRef as ReactComponent };